var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05 21C3.75 21 3.5 20.9 3.3 20.7C3.1 20.5 3 20.25 3 19.95V15.9C3 15.6833 3.075 15.4875 3.225 15.3125C3.375 15.1375 3.56667 15.0167 3.8 14.95L7.25 14.25C7.48333 14.2167 7.72083 14.2375 7.9625 14.3125C8.20417 14.3875 8.4 14.5 8.55 14.65L10.9 17C11.5333 16.6333 12.1333 16.2292 12.7 15.7875C13.2667 15.3458 13.8083 14.8667 14.325 14.35C14.875 13.8167 15.3792 13.2625 15.8375 12.6875C16.2958 12.1125 16.6917 11.5167 17.025 10.9L14.6 8.45C14.4667 8.31667 14.375 8.15833 14.325 7.975C14.275 7.79167 14.2667 7.56667 14.3 7.3L14.95 3.8C14.9833 3.58333 15.0917 3.39583 15.275 3.2375C15.4583 3.07917 15.6667 3 15.9 3H19.95C20.25 3 20.5 3.1 20.7 3.3C20.9 3.5 21 3.75 21 4.05C21 6.13333 20.5458 8.19167 19.6375 10.225C18.7292 12.2583 17.4417 14.1083 15.775 15.775C14.1083 17.4417 12.2583 18.7292 10.225 19.6375C8.19167 20.5458 6.13333 21 4.05 21ZM17.95 9C18.2333 8.35 18.45 7.69167 18.6 7.025C18.75 6.35833 18.8667 5.68333 18.95 5H16.75L16.3 7.35L17.95 9ZM9 17.9L7.35 16.25L5 16.75V18.95C5.68333 18.9 6.35833 18.7833 7.025 18.6C7.69167 18.4167 8.35 18.1833 9 17.9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2798a09f2b6de2a587d95252dba17b9a.svg";
export { ForwardRef as ReactComponent };